import { type FC, useContext, useMemo } from "react";
import { useDragDropComponent } from "./DragDropManager";
import { DragDropEditorContext } from "./DragDropTypes";
import { DragDropStyleField } from "./StyleFields/DragDropStyleField";

interface Props {
    id: string;
}

export const DragDropComponentSettings: FC<Props> = ({ id }) => {
    const { items, manager } = useContext(DragDropEditorContext);

    const component = useDragDropComponent(id);

    const item = useMemo(() => {
        if(!component) {
            return null;
        }

        const item = items[component.type];

        if(!item) {
            return null;
        }

        return item;
    }, [ component, items ]);

    if(!component || !item) {
        return null;
    }

    const Settings = item.settings;

    return (
        <div className="p-4 space-y-4">
            <h2>{item.name}</h2>
            <Settings
                id={id}
                value={component.value}
                style={component.style}
            />
            {item.styles.map(key => (
                <DragDropStyleField
                    key={key}
                    type={key}
                    value={component.style[key]}
                    onChange={value => {
                        manager.updateStyle(id, key, value);
                    }}
                />
            ))}
        </div>
    );
};
